export default __webpack_public_path__ + "static/media/imagem-satelite.cfcf83b5.svg";